import { CalendarShiftModel } from "@m481/mp-sdk-ng";

import { BaseEntity } from "./base.entity";
import { MissionEntity } from "./mission.entity";
import { ShiftEntity } from "./shift.entity";

export interface CalendarShiftEntity extends BaseEntity {
    shiftId: string;
    startAt: Date;
    endAt: Date;
    assignedUsers: Array<string>;
    shift?: ShiftEntity; //not in model
}

export class CalendarShiftEntityHelper {
    public static fromMission(missionEntity: MissionEntity, date: Date): Partial<CalendarShiftEntity> {
        const shiftStartAt = date.getTime();
        return {
            startAt: date,
            endAt: date,
            assignedUsers: [],
            shift: {
                id: undefined,
                teamId: missionEntity.teamId,
                missionId: missionEntity.id,
                missionHourIndex: missionEntity.allDay ? 0 : undefined,
                startAt: shiftStartAt,
                assignedUsersIds: [],
                isEnabled: missionEntity?.isEnabled ?? true,
                timespan: {
                    initialAt: shiftStartAt,
                    maxSlots: 1
                }
            }
        };
    }

    public static fromModel(model: CalendarShiftModel): CalendarShiftEntity {
        return {
            id: model.id,
            shiftId: model.shiftId,
            startAt: typeof model.startAt === "string" ? new Date(model.startAt) : model.startAt,
            endAt: typeof model.endAt === "string" ? new Date(model.endAt) : model.endAt,
            assignedUsers: model.assignedUsersIds || []
        };
    }

    public static toModel(entity: CalendarShiftEntity): CalendarShiftModel {
        return {
            id: entity.id,
            shiftId: entity.shiftId,
            startAt: typeof entity.startAt === "string" ? new Date(entity.startAt) : entity.startAt,
            endAt: typeof entity.endAt === "string" ? new Date(entity.endAt) : entity.endAt,
            assignedUsersIds: entity.assignedUsers
        };
    }

    public static getAssignedUsersIds(entity: CalendarShiftEntity): Array<string> {
        if (!entity.shift) {
            throw new Error("CalendarShiftEntity must have shift property set");
        }
        return [...new Set([...(entity.assignedUsers ?? []), ...(entity.shift?.assignedUsersIds ?? [])])];
    }

    public static belongsToSeries(entity: CalendarShiftEntity): boolean {
        if (!entity.shift) {
            throw new Error("CalendarShiftEntity must have shift property set");
        }
        return entity.shift.timespan?.maxSlots !== 1;
    }
}
